import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const VideoProgressMapa = ({ mapa }) => {
  const total = mapa.length;

  // Tạo segment cho từng ô trong mapa
  const segments = mapa.map((val, index) => ({
    now: (1 / total) * 100, // mỗi index chiếm 1 phần đều nhau
    striped: false,
    variant: val > 0 ? 'success' : 'white',
    key: index,
  }));

  return (
    <ProgressBar style={{ height: '10px', borderRadius: '5px', border: '1px solid #ccc' }}>
      {segments.map((seg) => (
        <ProgressBar {...seg} />
      ))}
    </ProgressBar>
  );
};

export default VideoProgressMapa;
